import { createFileRoute } from '@tanstack/react-router'
import { useSelector } from 'react-redux'
import { Stack } from '@mui/material'
import HgCircularProgressGlobal from '@/common/components/ui/atoms/HgCircularProgressGlobal'
import ProgramTeaser from '@/common/components/views/ProgramTeaser'
import { titleTagSuffix } from '@/common/constants'
import { Helmet } from '@/common/components/Helmet'
import CanonicalLink from '@/common/components/CanonicalLink'
import { values } from 'lodash'

export const Route = createFileRoute('/app/programs/')({
  component: RouteComponent,
})

function RouteComponent() {
  const appMeta = useSelector((state: any) => state.app_meta)
  const currentUser = useSelector((state: any) => state.auth.currentUser)
  const programs = useSelector((state: any) => state.programs)

  const ready = currentUser.loaded && appMeta.loaded && programs.loaded

  if (!ready) {
    return <HgCircularProgressGlobal />
  }

  return (
    <>
      <Helmet>
        <title>Programs{titleTagSuffix}</title>
        <meta
          name="description"
          content="Explore Alliance for a Healthier Generation programs that help schools and organizations build healthier environments through assessment, planning, and action."
        />
        <meta property="og:title" content="Programs" />
      </Helmet>
      <CanonicalLink path="/programs" />

      <h1 className="sr-only">Programs</h1>
      <Stack spacing={2}>
        {values(programs.data).map((program: any) => (
          <ProgramTeaser
            key={program.id}
            program={program}
            currentUser={currentUser}
          />
        ))}
      </Stack>
    </>
  )
}
